/**
 * Default feature-flag values (frontend).
 *
 * Mirrors the backend shape in
 * backend/src/modules/feature-flags/feature-flags.types.ts. Every flag
 * defaults to `true`, matching DEFAULT_FEATURE_FLAGS on the backend.
 */
export const DEFAULT_FEATURE_FLAGS = {
  leave: true,
  payroll: true,
  attendance: true,
  overtime: true,
  evaluations: true,
  complaints: true,
  recruitment: true,
};

/**
 * Fail-open parsing: a flag is only ever disabled when
 * scripts/apply-brand.ps1 wrote the literal string "false" for it (i.e.
 * brand.json had `"features": { "<key>": false }`). Missing env var
 * (no apply-brand run, plain `npm start`), any other string, or a typo
 * all resolve to enabled — never to a silent, unexpected disable.
 */
function readBuildFlag(envValue) {
  return envValue !== "false";
}

/**
 * Resolved from REACT_APP_FEATURE_* — written into `.env.production` by
 * scripts/apply-brand.ps1 from the active brand's `brand.json`
 * `features` object (see brands/<brand>/brand.json). This is the
 * build-time equivalent of the backend's
 * BrandConfigService -> CompanySettingsService -> features chain: the
 * same brand.json is the single source of truth for both.
 *
 * Brands with no "features" section at all (e.g. brands/ess/brand.json
 * today) produce REACT_APP_FEATURE_*=true for every key, so this is
 * identical to DEFAULT_FEATURE_FLAGS for them — zero behavior change.
 */
export const BRAND_FEATURE_FLAGS = {
  leave: readBuildFlag(process.env.REACT_APP_FEATURE_LEAVE),
  payroll: readBuildFlag(process.env.REACT_APP_FEATURE_PAYROLL),
  attendance: readBuildFlag(process.env.REACT_APP_FEATURE_ATTENDANCE),
  overtime: readBuildFlag(process.env.REACT_APP_FEATURE_OVERTIME),
  evaluations: readBuildFlag(process.env.REACT_APP_FEATURE_EVALUATIONS),
  complaints: readBuildFlag(process.env.REACT_APP_FEATURE_COMPLAINTS),
  recruitment: readBuildFlag(process.env.REACT_APP_FEATURE_RECRUITMENT),
};

export default DEFAULT_FEATURE_FLAGS;
